<template>
  <div class="transaction">

    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow">
          <div class="card-body">
            <card-title icon-image="mdi-recycle-variant" title="Transaction" text-color="title" />
            <MDKTable
                ref="MDKTable"
                :fields="fields"
                :items="items"
                :pagination="paginationOptions"
                v-on:filter-change="getItems" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CardTitle from '@/views/components/cardTitle.vue';

export default {
  components: { CardTitle },
  data() {
    const _api = this.$_app.service.transaction
    return {
      jqlApi: _api,
      fields: [
          _api.schema.transactionId,
          _api.schema.chargeBoxId,
          _api.schema.connectorId,
          _api.schema.idTag,
          _api.schema.startTimestamp,
          _api.schema.startMeterValue,
          _api.schema.stopTransaction.stopTimestamp,
          _api.schema.stopTransaction.stopMeterValue,
          _api.schema.stopTransaction.stopReason,
      ],
      items: [],
      paginationOptions: {
        currentPage: 1,
        totalCount : 0,
        perPage: 10,
      }
    }
  },
  mounted() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    getItems(filterOptions, sortOptions) {
      const vm = this;
      sortOptions = '-transactionId';
      vm.jqlApi.searchByJql(filterOptions, sortOptions, vm.paginationOptions.perPage, vm.$refs.MDKTable.currentPage)
          .then(res => {
            vm.items = res.content;
            vm.paginationOptions.totalCount = res.totalElements;
          }).catch(err => {
            console.log(err);
          });
    }
  }
}
</script>
